/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Field_Recovery_CodeInputs */



/**
* | output |
* | --- |
* | "Recovery Code" |
*
* @param {Form_Field_Recovery_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_field_recovery_code = /** @type {((inputs?: Form_Field_Recovery_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Field_Recovery_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellungscode")
	return /** @type {LocalizedString} */ ("Recovery Code")
});